import SignalboxLogo from "./SignalboxLogo";

export default SignalboxLogo;
